var err404;

err404 = function() {
  var $, DrawEye, eye1, eye2, module, moduleName;
  $ = require('jquery');
  moduleName = 'err404';
  module = $("." + moduleName);
  DrawEye = function(eyecontainer, eyepupil, speed, interval) {
    var follower, limitX, limitY, looper, mouseX, mouseY, offset, xp, yp;
    mouseX = 0;
    mouseY = 0;
    xp = 0;
    yp = 0;
    limitX = $(eyecontainer).width() - $(eyepupil).width();
    limitY = $(eyecontainer).height() - $(eyepupil).height();
    offset = $(eyecontainer).offset();
    $(window).mousemove(function(e) {
      mouseX = Math.min(e.pageX - offset.left, limitX);
      mouseY = Math.min(e.pageY - offset.top, limitY);
      if (mouseX < 0) {
        mouseX = 0;
      }
      if (mouseY < 0) {
        mouseY = 0;
      }
    });
    follower = $(eyepupil);
    looper = setInterval((function() {
      xp += (mouseX - xp) / speed;
      yp += (mouseY - yp) / speed;
      follower.css({
        left: xp,
        top: yp
      });
    }), interval);
  };
  if (module.length > 0) {
    eye1 = new DrawEye('.err404__eye--left', '.err404__pupil--left', 3, 30);
    return eye2 = new DrawEye('.err404__eye--right', '.err404__pupil--right', 3, 30);
  }
};

module.exports = err404;
